import { SVGProps } from 'react';
import {} from '@components/process-offline-sales/process-offline-sales.type';

import type { MultiOptionType } from './create-multi-selector-option.type';

export const createMultiSelectorOption = <Id extends MultiOptionType>({
  id,
  name,
  subtitle,
  icon,
  value,
  toggler,
}: {
  id: Id;
  name: string;
  subtitle: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  value: string;
  toggler: (id: Id) => void;
}) => ({
  name,
  subtitle,
  bordered: true,
  id,
  icon,
  active: value === id,
  wrapperClasses: 'flex-1',
  action: () => toggler(id),
});
